export enum ReportRoles {
    BASIC = 'REPORTS_BASIC',
    FINANCIALS = 'REPORTS_FINANCIALS',
}

export enum FeatureFlagRoles {
    EDIT_VEHICLE_SALE_CONDITIONS = 'EDIT_VEHICLE_SALE_INFO',
    IFS_AND_OFFERS = 'IF_OFFERS',
    VIEW_AND_MANAGE_DOCUMENTS = 'VIEW_EDIT_DOCS',
    ACTION_DRAWER = 'FEATURE_FLAG_4',
    PSI_MODULE = 'PSI_MODULE',
    // EDGE_AUCTION_ADMIN = 'EDGE_AUCTION_ADMIN',
    EDGE_AUCTION_ADMIN = 'FEATURE_FLAG_8',
    VIEW_FEES = 'FEATURE_FLAG_9',
    MODIFY_FEES = 'MODIFY_FEES',
}

export enum DocumentRoles {
    DELETE_DOCUMENTS = 'DELETE_DOCUMENTS',
}
